"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var constants_1 = require("../data/constants");
var CheckViewport_1 = __importDefault(require("./CheckViewport"));
var Counter = /** @class */ (function (_super) {
    __extends(Counter, _super);
    function Counter() {
        var _this = _super.call(this, constants_1.DATA_COUNTER) || this;
        _this.time = 2000;
        if (!_this.getElement())
            return _this;
        _this.counterElement = document.querySelectorAll("[".concat(constants_1.DATA_COUNTER, "]"));
        _this.counterElement.forEach(function (element) {
            _this.initCounter(element);
        });
        window.addEventListener('scroll', function () {
            _this.counterElement.forEach(function (element) {
                var counts = element.querySelectorAll('[data-count-start]');
                if (CheckViewport_1.default.checkIfInViewport(element)) {
                    if (!element.classList.contains('counted')) {
                        counts.forEach(function (count) {
                            var countStart = count.getAttribute('data-count-start');
                            var countEnd = count.getAttribute('data-count-end');
                            var start = _this.convertToNumber(countStart);
                            var end = _this.convertToNumber(countEnd);
                            _this.counter(start, end, count);
                        });
                        element.classList.add('counted');
                    }
                }
            });
        });
        return _this;
    }
    // Count number from start to end
    Counter.prototype.counter = function (start, end, el) {
        var interval = setInterval(function () {
            if (++start <= end) {
                el.firstElementChild.innerHTML = start.toString();
            }
            else {
                clearInterval(interval);
            }
        }, this.time / (end - start));
    };
    // Convert strings into numbers
    Counter.prototype.convertToNumber = function (item) {
        var convertUnknown = item;
        var convertNumber = convertUnknown;
        return convertNumber;
    };
    Counter.prototype.initCounter = function (el) {
        var _this = this;
        var counters = el.querySelectorAll('[data-count-start]');
        counters.forEach(function (count) {
            var countStart = count.getAttribute('data-count-start');
            var start = _this.convertToNumber(countStart);
            count.firstElementChild.innerHTML = start.toString();
        });
    };
    return Counter;
}(AbstractComponent_1.default));
exports.default = Counter;
